module.exports = __webpack_public_path__ + "img/blanket_4.b2a5d209.png";